import * as React from 'react';
import { EPaymentMethodType } from '../../../types/redux/paymentMethods';
import { CommonMethodContainer } from './components/CommonMethod';
import { LinkedCardContainer } from './components/LinkedCard';
import { FastPaymentSystem } from './components/FastPaymentSystem';
import { decodePaymentMethodId } from '../../../utils/paymentMethods';

interface IProps {
  id: string;
}

export const PaymentMethodContainer = (props: IProps) => {
  const { id } = props;

  const { type } = React.useMemo(() => decodePaymentMethodId(id), [id]);

  if (type === EPaymentMethodType.SBP) {
    return <FastPaymentSystem id={id} />;
  }

  if (type === EPaymentMethodType.LinkedCard) {
    return <LinkedCardContainer id={id} />;
  }

  return <CommonMethodContainer id={id} />;
};
